// TODO: Add jslint header
define('core',['jquery', 'validation', 'modal', 'migrate'], function ($) {
    'use strict';
    var $document = $(document);

    //
    // JQUERY EXTENSIONS
    //
    $.fn.andFind = function (selector) {
        return this.filter(selector).add(this.find(selector));
    };

    $.fn.relativeFind = function (path) {
        // Syntax:
        //   @< selector - go up
        //   @> selector - go down
        if (this.length && path && path[0] == '@') {
            var current = this,
                parts = path.substr(1).split('@'),
                i = 0,
                partsCount = parts.length;
            while (i < partsCount && current.length) {
                var part = parts[i++];
                if (part) {
                    var selector = part.substr(1);
                    current = (part[0] == '<') ? current.closest(selector) : current.find(selector);
                }
            }
            return current;
        }
        return $(path);
    };

    //
    // OTHER EXTENSIONS
    //
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (elt) {
            var len = this.length >>> 0;
            var from = Number(arguments[1]) || 0;
            from = (from < 0)
                ? Math.ceil(from)
                : Math.floor(from);
            if (from < 0)
                from += len;

            for (; from < len; from++) {
                if (from in this &&
                    this[from] === elt)
                    return from;
            }
            return -1;
        };
    }
    // TODO: Review
    $.validator.prototype.focusInvalid = function () {
        if (this.settings.focusInvalid) {
            try {
                var body = $('html, body'),
                    activeElement = $(this.errorList.length && this.errorList[0].element || []).filter(':visible').closest('.form-field, .checkbox-wrapper');
                if (!$('html').hasClass('modal-on') && !$('html').hasClass('panel-opened')) {
                    if (activeElement.length && core.ui.isElementInViewport(activeElement) == false) {
                        body.animate({ scrollTop: activeElement.closest('.form-field, .checkbox-wrapper').offset().top - (activeElement.height() * 2 + 40) }, '500', 'swing', function () {
                            $(this).trigger('focusin');
                            // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                        });
                    }
                } else {
                    $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(':visible').focus().trigger('focusin');
                }
            } catch (e) {
                // ignore IE throwing errors when focusing hidden elements
            }
        }
    };
    //
    // SCOPES
    //
    var scopes = {};

    function Scope(scopeName, initialHandler) {
        this.scopeName = scopeName;
        this.handlers = [initialHandler];
        this.addHandler = function (handler) {
            this.handlers.push(handler);
            initializeHandler(handler);
        }
        this.removeHandler = function (handler) {
            var position = this.handlers.indexOf(handler);
            if (position > 0) {
                this.handlers.splice(position, 1);
            }
        }
        this.update = function (context) {
            var name = this.scopeName;
            $.each(this.handlers, function (index, handler) {
                try {
                    handler(context);
                } catch (e) {
                    window.console && console.log('Handler ' + name + ':' + (handler.name || 'fn') + ' failed: ' + e);
                }
            });
        }

        initializeHandler(initialHandler);

        function initializeHandler(handler) {
            // Initial scope processing
            $document.ready(function () {
                window.console && console.log('#' + scopeName + ': ' + (handler.name || 'fn'));
                if (scopeName == '*') {
                    handler($document);
                } else {
                    $document.find('.js-scope[data-scope="' + scopeName + '"]').each(function () {
                        handler($(this));
                    });
                }
            });
        }
    }

    //
    // MODULE
    //
    var core = {
        //
        // BASIC FUNCTIONS
        //
        functions: {
            toCallback: function (callback) {
                return (callback)
                    ? (typeof callback === 'function') ? callback : function () {
                        return callback;
                    }
                    : function () {
                    };
            },

            setUrlParameter: function (url, parameter, value) {
                return url.replace('-p' + parameter + '-', encodeURIComponent(value));
            },

            getPropertiesCount: function (obj) {
                var count = 0;
                for (var property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        count++;
                    }
                }
                return count;
            }
        },
        //
        // ENCODING
        //
        encode: {
            html: function (value) {
                return String(value)
                    .replace('&', '&amp;')
                    .replace('"', '&quot;')
                    .replace('<', '&lt;')
                    .replace('>', '&gt;');
            },

            list: function (values) {
                return $.isArray(values) ? values.join(',') : '' + values;
            }
        },
        //
        // DECODING
        //
        decode: {
            html: function (value) {
                return String(value)
                    .replace('&quot;', '"')
                    .replace('&lt;', '<')
                    .replace('&gt;', '>')
                    .replace('&amp;', '&');
            },

            json: function (expression) {
                if (expression) {
                    try {
                        if (typeof expression === 'string' && expression[0] === '{') {
                            return (new Function('return ' + expression)());
                        }
                    } catch (e) {
                        window.console && console.log('Could not decode expected JSON expression: ' + expression);
                    }
                }
                return expression;
            },

            list: function (values) {
                if (values) {
                    return typeof values === 'string' ? values.split(',') : [values];
                }
                return [];
            }
        },
        //
        // SCOPES CONTROL
        //
        scopes: {
            addHandler: function (scopeName, handler) {
                var scope = scopes[scopeName];
                if (scope) {
                    scope.addHandler(handler);
                } else {
                    scopes[scopeName] = new Scope(scopeName, handler);
                }
            },

            removeHandler: function (scopeName, handler) {
                var scope = scopes[scopeName];
                if (scope) {
                    scope.removeHandler(handler);
                }
            },

            update: function (context) {
                var $context = $(context),
                    parentScopes = { '*': true };
                scopes['*'].update($context);
                $context.parents('.js-scope').each(function () {
                    var $this = $(this),
                        scopeName = $this.data('scope');
                    parentScopes[scopeName] = true;
                    var scope = scopes[scopeName];
                    if (scope) {
                        scope.update($context);
                    }
                });
                $context.andFind('.js-scope').each(function () {
                    var $this = $(this),
                        scopeName = $this.data('scope');
                    if (parentScopes[scopeName]) {
                        return;
                    }
                    var scope = scopes[scopeName];
                    if (scope) {
                        scope.update($this);
                    }
                });
            },

            on : function(eventName, eventHandler) {
                $document.on(eventName, eventHandler);
            }
        },
        //
        // DOM HELPERS
        //
        dom: {
            bindActionHandler: function (nodes, handler) {
                nodes.each(function () {
                    var $this = $(this),
                        action = $this.data('action');
                    if (!action) {
                        switch ($this.prop('tagName')) {
                            case 'FORM':
                                action = 'submit';
                                break;
                            case 'SELECT':
                                action = 'change';
                                break;
                            default:
                                action = 'click';
                                break;
                        }
                    }
                    $this.on(action, handler);
                });
            },

            doAction: function (node, callback) {
                defaultActionHandler.call(node, null, callback);
            }
        },
        //
        // UI HELPERS
        //
        ui: {
            lock: function (location, container, immediately) {
                switch (location) {
                    case 'screen':
                        container = $('body');
                        break;
                    case 'container':
                        break;
                    default:
                        container = (container)
                          ? $(container).relativeFind(location)
                            : $(location || 'body');
                        break;
                }
                if (container.length) {
                    var timerId = setTimeout(function () {
                        container.addClass('preloading');
                    }, immediately ? 0 : 300);

                    return {
                        timerId: timerId,
                        container: container
                    };
                }
                return { container : $() };
            },

            unlock: function (lockContext) {
                if (lockContext) {
                    clearTimeout(lockContext.timerId);
                    lockContext.container.removeClass('preloading');
                }
            },

            scrollTo: function (selector, container) {
                var scrollTo = container ? container.relativeFind(selector) : $(selector);
                if (scrollTo.length) {
                    $('html, body').stop(true, false).animate({ scrollTop: scrollTo.offset().top /*- core.ui.getStickyHeaderHeight()*/ }, 800);
                }
            },

            showMessages: function(messagesContainer, messages) {
                var userMessages = messagesContainer.find('.user-message');
                userMessages.empty();

                if (!messages || !messages.length) {
                    messagesContainer.hide();
                } else {
                    if (!Array.isArray(messages)) {
                        messages = [messages];
                    }

                    var html = '';
                    $.each(messages, function (i, message) {
                        html += '<p>' + message + '</p>';
                    });
                    userMessages.html(html);
                    messagesContainer.show();
                    if (messagesContainer && !$.isEmptyObject(messagesContainer) && !core.ui.isElementInViewport(messagesContainer)) {
                        $('html, body').stop(true, false).animate({ scrollTop: messagesContainer.offset().top }, 800);
                    }
                }
            },

            alert: function (options, callback) {
                options = core.decode.json(options);
                callback = core.functions.toCallback(callback);
                $.openModal($.extend({
                    templateId: 'alert-template',
                    transition: false,
                    onOpened: function () {
                        var content = this.contentContainer;
                        if (options.title) {
                            this.titleContainer.html(options.title);
                        }
                        if (options.message) {
                            content.find('[data-modal-alert="message"]').html(options.message);
                        }
                        if (options.className) {
                            content.closest('[data-modal-class="class"]').addClass(options.className);
                        }
                    },
                    onClose: function () {
                        callback();
                        return true;
                    }
                }), options);
            },

            confirm: function (options, callback) {
                options = core.decode.json(options);
                callback = core.functions.toCallback(callback);
                if (!options) {
                    callback(true);
                    return;
                }
                if (typeof options === 'object') {
                    var confirmationPopupOptions = {
                        templateId: 'confirmation-template',
                        transition: false,
                        onOpened: function() {
                            var content = this.contentContainer,
                                confirmButton = content.find('[data-modal-confirmation="confirm"]');
                            if (options.title) {
                                this.titleContainer.html(options.title);
                            }
                            if (options.message) {
                                content.find('[data-modal-confirmation="message"]').html(options.message);
                            }
                            if (options.className) {
                                content.closest('[data-modal-class="class"]').addClass(options.className);
                            }
                            if (options.confirmButton) {
                                confirmButton.html(options.confirmButton);
                            }
                            if (options.cancelButton) {
                                content.find('[data-modal-confirmation="cancel"]').html(options.cancelButton);
                            }
                            confirmButton.on('click', function(event) {
                                event.preventDefault();
                                confirmationPopup.close();
                                callback(true);
                            });
                        },
                        onClose: function () {
                            callback(false);
                            return true;
                        }
                    };

                    if (options.htmlClass) {
                        confirmationPopupOptions.htmlClass = options.htmlClass;
                    }

                    var confirmationPopup = $.openModal($.extend(confirmationPopupOptions));
                } else {
                    callback(window.confirm(options));
                }
            },

            //This is default sticky header calculation function. You can assign your own function.
            getStickyHeaderHeight: function () { //TODO: review after design changes
                var height = 0;

                var siteHeader = $('.js-site-header:visible');
                if (siteHeader.length) {
                    height += siteHeader.outerHeight();
                }

                var additionalHeader = $('.js-in-page-navigation:visible');
                if (additionalHeader.length) {
                    height += additionalHeader.outerHeight();
                }

                //Add some margin
                if (height > 0) {
                    height += 5;
                }

                return height;
            },

            //E7+, iOS5+ Safari, Android2+, Blackberry, Opera Mobile, IE Mobile
            isElementInViewport: function(el, onlyTopVisible) {
                //special bonus for those using jQuery
                if (typeof jQuery === "function" && el instanceof jQuery) {
                    el = el[0];
                }

                var stickyHeaderHeight = core.ui.getStickyHeaderHeight();

                var rect = el.getBoundingClientRect();

                return (rect.top >= stickyHeaderHeight &&
                        rect.left >= 0 &&
                        (onlyTopVisible || 
                            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                            rect.right <= (window.innerWidth || document.documentElement.clientWidth))
                );
            },
        },

        cookie: {
            put: function (key, value, options) {
                if (!key) {
                    return;
                }
                var cookie = key + '=';
                options = $.extend({ path: '/' }, options);
                if (value === null || options.expires < 0) {
                    options.expires = -1;
                } else {
                    cookie += value;
                }
                if (typeof options.expires === "number") {
                    var timestamp = new Date();
                    timestamp.setTime(timestamp.getTime() + options.expires);
                    options.expires = timestamp;
                }
                if (options.expires) {
                    cookie += '; expires=' + options.expires.toUTCString();
                }
                if (options.domain) {
                    cookie += '; domain=' + options.domain;
                }
                if (options.path) {
                    cookie += '; path=' + options.path;
                }
                document.cookie = cookie;
            },

            all: function () {
                var cookies = document.cookie.split('; '),
                    count = cookies.length,
                    result = {};
                for (var i = 0; i < count; i++) {
                    var cookie = cookies[i],
                        position = cookie.indexOf('='),
                        key = cookie.substr(0, position),
                        value = cookie.substr(position + 1);
                    result[key] = value;
                }

                return result;
            },

            get: function (key) {
                if (!key) {
                    return null;
                }

                return core.cookie.all()[key];
            },

            remove: function (key) {
                core.cookie.put(key, null);
            }
        }
    }
    //
    // CORE HANDLER
    //
    var ATTR_ACTION_IN_PROGRESS = 'actionInProgress';

    function defaultActionHandler(event, callback) {
        if (event) {
            if (event.preventDefault) { //preventDefault is added by jquery so it should work always
                event.preventDefault();
            }

            // jQuery fix for IE8
            if (!$.support.leadingWhitespace) {
                event.returnValue = false;
                event.cancelBubble = true;
            } else {
                event.stopPropagation();
            }
        }
        var node = $(this);
        if (node.data(ATTR_ACTION_IN_PROGRESS)) {
            return;
        }
        // Get context
        var actionContext = $.extend({}, node.data());
        node.data(ATTR_ACTION_IN_PROGRESS, true);
        actionContext.url = actionContext.url || node.attr('href') || node.attr('action');
        actionContext.container = (actionContext.container)
            ? node.relativeFind(actionContext.container)
            : node;
        actionContext.messagesContainer = (actionContext.messages)
            ? node.relativeFind(actionContext.messages)
            : node.find('.js-messages');
        actionContext.messages = null;
        actionContext.messagesContainer.hide();
        // Check and validate form
        var form = node.closest('form'),
            isform = node.prop('tagName') == 'FORM',
            isSelect = node.prop('tagName') == 'SELECT',
            nodeOriginalValue = node.data('originalValue');
        if ((node.data('validate') || isform) && form.length) {
            form.validate();
            if (!form.valid()) {
                node.data(ATTR_ACTION_IN_PROGRESS, false);
                return;
            }
        }
        // Confirm
        core.ui.confirm(actionContext.confirmation, function (confirmed) {
            if (!confirmed) {
                node.data(ATTR_ACTION_IN_PROGRESS, false);
                if (isSelect && nodeOriginalValue) {
                    node.val(nodeOriginalValue);
                }
                return;
            }
            actionContext.lock = core.ui.lock(actionContext.lock, actionContext.container);
            // AJAX call
            var ajaxParameters = {
                type: 'POST',
                dataType: 'json'
            }
            if (isform) {
                ajaxParameters.type = form.prop('method') || ajaxParameters.type;
                ajaxParameters.data = form.serialize();
            }
            if (isSelect) {
                ajaxParameters.data = actionContext.jsondata || {};
                ajaxParameters.data.selectedValue = node.val();
            }
            $.ajax(actionContext.url, ajaxParameters)
                .done(function (response) {
                    defaultResponseHandler(response, actionContext);
                }).fail(function (response) {
                    actionContext.lock.container = $();
                    if (response.status === 401) {
                        window.location.href = window.portal.settings.urlLogin;
                    } else if (response.status !== 0) {
                        window.location.href = core.functions.setUrlParameter(window.portal.settings.urlServerError, 1, actionContext.url);
                    }
                }).always(function (response) {
                    node.data(ATTR_ACTION_IN_PROGRESS, false);
                    core.ui.unlock(actionContext.lock);
                    core.functions.toCallback(callback)(response);
                });
        });
    }

    function defaultResponseHandler(response, context) {
        //Merge context with response properties
        $.each(response, function (key, value) {
            if (value) {
                var normalizedKey = key[0].toLowerCase() + key.substring(1);
                if (normalizedKey === "notification") {
                    var newValue = {};
                    $.each(value, function (subKey, subValue) {
                        var normalizedSubKey = subKey[0].toLowerCase() + subKey.substring(1);
                        if (subValue) {
                            newValue[normalizedSubKey] = subValue;
                        }
                    });
                    context[normalizedKey] = newValue;
                } else {
                    context[normalizedKey] = value;
                }
            }
        });

        if (context.keepLock) {
            keepLock();
        }

        var container = context.container;
        if (context.redirectUrl) {
            withNotification(function () {
                window.location.href = context.redirectUrl;
            });
            if (!context.notification) {
                keepLock();
            }
            return;
        }
        if (context.refresh) {
            withNotification(function () {
                window.location.reload();
            });
            keepLock();
            return;
        }
        if (context.success) {
            if (context.content) {
                replaceContent(container, context.content);
            }
            if (context.contentUpdates) {
                $.each(context.contentUpdates, function (locator, content) {
                    replaceContent(container.relativeFind(locator), content);
                });
            }
            if (context.valueUpdates) {
                $.each(context.valueUpdates, function (locator, value) {
                    replaceValue(container.relativeFind(locator), value);
                });
            }
            if (context.events) {
                $.each(context.events, function (eventName, eventData) {
                    $document.trigger(eventName, [eventData, container]);
                });
            }
            if (context.closeModal) {
                $.closeModal(true);
            }
            if (context.scrollTo) {
                core.ui.scrollTo(context.scrollTo, container);
            }
            if (context.showContent) {
                $.each(core.decode.list(context.showContent), function () {
                    container.relativeFind(this).show();
                });
            }

            // Hide specified content
            if (context.hideContent) {
                $.each(core.decode.list(context.hideContent), function () {
                    container.relativeFind(this).hide();
                });
            }
        } else {
            if (context.ajaxErrorsForFields && !$.isEmptyObject(context.ajaxErrorsForFields)) {
                container.find('span.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').html('');
                container.find('.input-validation-error').removeClass('input-validation-error').addClass('valid');

                var validator = container.validate();
                validator.showErrors(context.ajaxErrorsForFields);
                validator.focusInvalid();
            }
        }

        if (context.messagesContainer.length) {
            core.ui.showMessages(context.messagesContainer, context.messages);
        }

        if (context.notification) {
            core.ui.alert(context.notification);
        }

        function withNotification(action) {
            if (context.notification) {
                core.ui.alert(context.notification, action);
            } else {
                action();
            }
        }

        function replaceContent(nodes, content) {
            nodes.each(function () {
                var $content = $(content);
                $(this).replaceWith($content);
                core.scopes.update($content);
            });
        }

        function replaceValue(nodes, value) {
            nodes.each(function () {
                $(this).val(value);
            });
        }

        function keepLock() {
            if (context.lock) {
                context.lock.container = $();
            }
        }
    }

    function defaultModalActionHandler(event) {
        var self;
        self = $(this);
        if (event) {
            event.preventDefault();
        }
        self.openModal({
            onClose: function() {
                $(document).trigger("modal-closed");
            },
            onLoad: function() {
                $(document).trigger("modal-loaded");
            },
            onOpened: function() {
                $(document).trigger("modal-opened");
            }
        });
    }

    //Custom modal.js functionality
    function customModalFunctionality() {
        var contentFromPrototype = $.Modal.prototype.content;
        $.Modal.prototype.content = function (value) {
            contentFromPrototype.call(this, value);
            core.scopes.update(this.contentContainer);

            var $context = this.context;
            $context.addClass('modal-loaded'); //To show modal after loaded
            setTimeout(function () {
                $context.addClass('modal-animate'); //To animate modal after show
            }, 1);
        };

        var loadContentFromPrototype = $.Modal.prototype.loadContent;
        $.Modal.prototype.loadContent = function () {
            loadContentFromPrototype.call(this);
            $(this).trigger('opened');
        };

        var initFromPrototype = $.Modal.prototype.init;
        $.Modal.prototype.init = function () {
            initFromPrototype.call(this);
            $(this).on('opened', this.options.onOpened || function () { });
        };

        $.getLastModal = function () {
            var openModals = this.Modal.openModals();
            if (openModals.length === 0) {
                return null;
            }

            return openModals[openModals.length - 1];
        };
        $.closeModal = function (force) {
            var modal = $.getLastModal();

            if (modal) {
                modal.close(force);
            }
        };
        $.closeAllModals = function () {
            var modal;

            while (modal = $.getLastModal()) {
                modal.close(true, true);
            }
        };
    }

    function defaultScopeHandler(context) {
        // Initialize validation
        $.validator.unobtrusive.parse(context);
        // Add action handlers
        core.dom.bindActionHandler(context.andFind('.js-action'), defaultActionHandler);
        core.dom.bindActionHandler(context.andFind('.js-modal'), defaultModalActionHandler);
        // Submit button fix
        context.andFind('.js-submit-button').attr('type', 'submit');
        //If you want to lock screen after link is clicked, please add this class to link
        core.dom.bindActionHandler(context.andFind('.js-lock-screen'), function() {
            var lockContext = core.ui.lock('screen', undefined, true);
            setTimeout(function() {
                core.ui.unlock(lockContext);
            }, 3000);
        });
    }

    core.scopes.addHandler('*', defaultScopeHandler);

    customModalFunctionality();

    return core;
});

